import { render, staticRenderFns } from "./MypageAuthenticationModal.vue?vue&type=template&id=64256696&scoped=true"
import script from "./MypageAuthenticationModal.vue?vue&type=script&lang=js"
export * from "./MypageAuthenticationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64256696",
  null
  
)

export default component.exports